import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';
import { Css, Responsive } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';
import { solicitationListHeaderStyles } from './Column.styles';

interface ISolicitationLocationProps {
	location: string[];
}

const styles = css`
	display: flex;
	width: 64px;
	max-width: 64px;
	margin-right: ${Css.pxToRem(40)};
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
	${solicitationListHeaderStyles}
	color: ${Color.Neutral6};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}
`;

export const StyledCell = styled(BaseCell)`
	${styles}
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: location;
		max-width: ${Css.pxToRem(78)};
		width: 100%;
	}
`;

const Location = styled.div`
	font-weight: 500;
	font-size: ${Css.pxToRem(16)};
	line-height: ${Css.pxToRem(19)};
	max-width: fit-content;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		inline-size: min-content;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		flex-direction: column;
		justify-content: center;
		font-size: ${Css.pxToRem(14)};
		width: max-content;
		margin-bottom: ${Css.pxToRem(1)};
	}
`;

export function Header() {
	return <StyledHeader css={styles}>Location</StyledHeader>;
}

export function Cell({ location }: ISolicitationLocationProps) {
	return (
		<StyledCell css={styles}>
			<Location>{location.join(', ')}</Location>
		</StyledCell>
	);
}
